module.exports = __webpack_public_path__ + "img/lv.9697c1c5.svg";